export const FIND_ASSIGNABLE_PRODUCT_ADDONS = `
  query FindAssignableAddonsForProduct($filter: FindAssignableProductAddonsFilter!, $page: PageRequest, $orderBy: OrderByInput) {
    product {
      findAssignableAddonsForProduct(filter: $filter, page: $page, orderBy: $orderBy) {
        count
        limit
        offset
        items { id name inAssignments }
      }
    }
  }
`;
